(function ($) {
  'use strict';
  var alreadyProcessed = function (component) {
    var processed = false;
    if ($(component).attr("type") == 'radio') {
      $('input:radio[name=' + $(component).attr('name') + ']').each(function () {
        if ($(this).hasClass('skipTrigger_processed')) {
          processed = true;
          return false;
        }
      });
    } else {
      if ($(component).hasClass('skipTrigger_processed')) {
        processed = true;
      }
    }
    return processed;
  };
  var defaults = {
  };
  var methods = {
    init: function (aOptions) {

      var settings = $.extend({}, defaults, aOptions);
      return $(this).each(function () {
        if (alreadyProcessed(this)) {
          return;
        }

        var $this = $(this), //the widget (also the trigger)
          data = $this.data('widget'),
          target = $('#' + $this.attr('data-skipTarget')), //element with skip pattern fields
          targets = $this.skipTrigger('getTargets'), //element with skip pattern fields
          triggeringValue = $this.attr('value'); //value that exposes skip pattern fields
        var triggeringValues = $this.skipTrigger('getTriggeringValues');

        $this.addClass('skipTrigger_processed');

        // Bind the change handler
        $this.skipTrigger('bindChangeEvent');

        // set up the widget's data
        if (!data) {
          $this.data('settings', settings);
          $this.data('target', target);
          $this.data('targets', targets);
          $this.data('triggeringValue', triggeringValue);
          $this.data('triggeringValues', triggeringValues);
        }

        // Toggle based on data
        $this.skipTrigger('toggleTarget');

      });
    },
    getTargets: function () {
      var $this = this;
      var targets = {};

      if ($this.skipTrigger('getTriggerFormType') == 'radio') {
        $('input:radio[name=' + $this.attr('name') + ']').each(function () {
          var targetId = $(this).attr('data-skipTarget');
          if (typeof targetId != 'undefined' && targetId) {
            if (typeof targets[targetId] == 'undefined') {
              targets[targetId] = [];
            }

            targets[targetId].push($(this).val());
          }
        });
      } else if ($this.skipTrigger('getTriggerFormType') == 'option') {
        if ($this.parent('select').hasClass('skipTrigger_processed')) {
          return;
        }
        $this.parent('select').find('option').each(function () {
          var targetId = $(this).attr('data-skipTarget');
          if (typeof targetId != 'undefined' && targetId) {
            if (typeof targets[targetId] == 'undefined') {
              targets[targetId] = [];
            }
            targets[targetId].push($(this).val());
          }
        });
        $this.parent('select').addClass('skipTrigger_processed');
      } else {
        var targetId = $(this).attr('data-skipTarget');
        targets[targetId] = new Array($(this).val());
      }
      // console.log(targets);
      return targets;
    },
    getTriggeringValues: function () {
      var $this = $(this);
      var values = [];
      var formType = $this.skipTrigger('getTriggerFormType');
      if (formType == 'radio') {
        $('input:radio[name=' + $this.attr('name') + ']').each(function () {
          var trigger = $(this).attr('data-skipTarget');
          if (typeof trigger != 'undefined' && trigger) {
            values.push($(this).attr('value'));
          }
        });
      } else if (formType == "option") {
        $this.parent().find('option').each(function () {
          var trigger = $(this).attr('data-skipTarget');
          if (typeof trigger != 'undefined' && trigger) {
            values.push($(this).attr('value'));
          }
        });
      } else {
        values.push($this.attr('value'));
      }
      return values;
    },
    bindChangeEvent: function () {
      var $this = $(this);
      if ($this.skipTrigger('getTriggerFormType') == 'radio') {
        $('input:radio[name=' + $this.attr('name') + ']').on('change', function (evt) {
          $this.skipTrigger('toggleTarget');
        });
      } else if ($this.skipTrigger('getTriggerFormType') == 'option') {
        $this.parent('select').on('change', function (evt) {
          $this.skipTrigger('toggleTarget');
        });
      } else {
        $this.on('change', function (evt) {
          $this.skipTrigger('toggleTarget');
        });
      }
    },
    toggleTarget: function () {
      var $this = this, //the widget (also the trigger)
        data = $this.data();

      if ($this.skipTrigger('getTriggerFormType') == 'checkbox') {
        if ($this.prop('checked')) {
          data.target.fadeIn('fast', function () {
            $(this).trigger('show');
          });
        } else {
          data.target.fadeOut('fast', function () {
            $(this).trigger('hide');
          });
          data.target.find('input[type=text]').val('');
          data.target.find('input[type=radio],input[type=checkbox]').prop('checked', false);
        }
      } else {
        var triggerFieldVal = $this.skipTrigger('getTriggerFieldValue');
        // foreach of the targets 
        // check to see if the triggerFieldVal is in the values array
        var formType = $this.skipTrigger('getTriggerFormType');
        for (var id in data.targets) {
          if (formType == 'radio' || formType == 'option') {
            if (data.targets[id].indexOf(triggerFieldVal) > -1) {
              $('#' + id).fadeIn('fast', function () {
                $(this).trigger('show');
              });
            } else {
              $('#' + id).fadeOut('fast', function () {
                $(this).trigger('hide');
              });

              $('#' + id).find('input, textarea, select').not('input[type=radio],input[type=checkbox]').each(function () {
                $(this).val('').trigger('change');
              });

              $('#' + id).find('input[type=radio],input[type=checkbox]').each(function () {
                $(this).prop('checked', false).trigger('change');
              });
            }
          } else {
            if (typeof triggerFieldVal != 'undefined' && triggerFieldVal !== '') {
              $('#' + id).fadeIn('fast', function () {
                $(this).trigger('show');
              });
            } else {
              $('#' + id).fadeOut('fast', function () {
                $(this).trigger('hide');
              });
              $('#' + id).find('input, textarea, select').not('input[type=radio],input[type=checkbox]').each(function () {
                $(this).val('').trigger('change');
              });
              $('#' + id).find('input[type=radio],input[type=checkbox]').each(function () {
                $(this).prop('checked', false).trigger('change');
              });
            }
          }
        }
      }
    },
    getTriggerFormType: function () {
      let $this = $(this),
        tagName = $this.prop('tagName').toLowerCase();
      switch (tagName) {
        case 'option':
          return 'option';
        case 'select':
          return 'select';
        default:
          let inputType = $this.attr('type').toLowerCase();
          switch (inputType) {
            case 'date':
            case 'search':
            case 'color':
            case 'date':
            case 'datetime':
            case 'datetime-local':
            case 'email':
            case 'month':
            case 'number':
            case 'range':
            case 'search':
            case 'tel':
            case 'time':
            case 'url':
            case 'week':
              return 'text';
            default:
              return inputType;
          }
      }
    },
    getTriggerFieldValue: function () {
      var $this = $(this),
        $el = $this,
        formFieldType = $this.skipTrigger('getTriggerFormType');

      switch (formFieldType) {
        case 'radio':
          return $('input:radio[name=' + $el.attr('name') + ']:checked').val();
        case 'option':
          $el = $this.parent('select');
        default:
          return $el.val();
      }
    },
  };

  $.fn.skipTrigger = function (method) {
    if (methods[method]) {
      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof method === 'object' || !method) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + method + ' does not exist on jQuery.skipTrigger');
    }
  };
}(jQuery));